import {
  $ArithmeticOperation,
  $JtfMode,
  $ModuleArea,
  ModuleArea,
} from '@suntex.fim/enums';

import { NodeModel } from '../../../types';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.JustTheFacts);

export const jtfNode = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 2,
  },
  color: moduleAreaDesc.color,
  layout: 'modes',
  children: $JtfMode.describeAll().map(
    (mode) =>
      ({
        tag: mode.slug,
        icon: `modes/${mode.slug}`,
        label: {
          aria: mode.label,
        },
        filtered: {
          label: `JTF ${mode.label}`,
        },
        color: mode.color,
        layout: 'operations',
        children: $ArithmeticOperation.describeAll().map(
          (op) =>
            ({
              moduleSlug:
                mode.slug === 'num'
                  ? `jtf-100-${op.slug}`
                  : `jtf-100-${mode.slug}-${op.slug}`,
              dataPath: ['jtf', '10x10', mode.slug, op.slug],
              href: `/modules/just-the-facts/${mode.slug}/${op.slug}`,
              color: op.color,
              icon: `operations/${op.slug}`,
              label: {
                aria: `JTF ${mode.label}\n${op.label}`,
              },
              filtered: {
                icon: `alts/jtf-${op.slug}`,
                label: `JTF ${mode.label}\n${op.label}`,
                color: moduleAreaDesc.color,
              },
            }) as const,
        ),
      }) as const,
  ),
} as const satisfies NodeModel;
